import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, utilityStyles } from './../../styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1icn1af",
  styles: "transform:rotate(270deg)"
} : {
  name: "yn8zz8-rotationStyles",
  styles: "transform:rotate(270deg);label:rotationStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "21xn5r",
  styles: "transform:rotate(180deg)"
} : {
  name: "aqpzxw-rotationStyles",
  styles: "transform:rotate(180deg);label:rotationStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "jbgpyq",
  styles: "transform:rotate(90deg)"
} : {
  name: "1nifpkk-rotationStyles",
  styles: "transform:rotate(90deg);label:rotationStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var rotationStyles = function rotationStyles(_ref4) {
  var rotation = _ref4.rotation;
  switch (rotation) {
    case 90:
      return _ref3;
    case 180:
      return _ref2;
    case 270:
      return _ref;
  }
};
export var meshIconColor = function meshIconColor(color, isInverse) {
  if (isInverse === true) {
    switch (color) {
      case 'community':
        return colors.coral_300;
      case 'success':
        return colors.green_300;
      case 'protection':
        return colors.purple_300;
      case 'information':
        return colors.lightBlue_500;
      default:
        return colors.white;
    }
  }
  var iconColors = {
    'blue-dark': colors.navy_500,
    primary: colors.blue_500,
    'alert-yellow': colors.yellow_700,
    'alert-green': colors.green_700,
    'alert-blue': colors.blue_500,
    'alert-red': colors.red_500,
    'alert-gray': colors.coolGray_900,
    community: colors.coral_700,
    success: colors.green_700,
    protection: colors.purple_700,
    information: colors.blue_500,
    black: colors.black,
    'coolGray-900': colors.coolGray_900,
    'coolGray-800': colors.coolGray_800,
    'coolGray-700': colors.coolGray_700,
    'coolGray-600': colors.coolGray_600,
    'coolGray-500': colors.coolGray_500,
    'coolGray-400': colors.coolGray_400,
    'coolGray-300': colors.coolGray_300,
    'coolGray-200': colors.coolGray_200,
    'coolGray-100': colors.coolGray_100,
    white: colors.white
  };
  return iconColors[color] || color;
};
var hasBorderStyles = function hasBorderStyles(_ref5) {
  var hasBorder = _ref5.hasBorder;
  if (hasBorder) {
    return /*#__PURE__*/css(">circle{fill:transparent;stroke:", colors.green_500, ";stroke-width:2;transform:scale(2);transform-origin:center;}>path{transform:scale(1.25);transform-origin:-75% -75%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:hasBorderStyles;"));
  }
};
var resetStyles = getResetByTag('svg');
var StyledIcon = /*#__PURE__*/_styled('svg', process.env.NODE_ENV === "production" ? {
  target: "e1ol8bq0"
} : {
  target: "e1ol8bq0",
  label: "StyledIcon"
})(resetStyles, rotationStyles, hasBorderStyles, utilityStyles);
export default StyledIcon;